const lang = {
    ja: {
        'register.advertisement': '広告',
        'register.numberAdv': '広告搭載申込み件数',
        'register.item': '件',
        'register.feeAdv': '1．広告料金 ',
        'register.locationAdv': '2．広告搭載は「展示サイトのTOP画面の下部」 「出展者一覧の下部」',
        'register.displayPlaceAdv': '「喫茶提示ルームの下部」 と「展示会出口サイト」の4ヶ所に表示',
        'register.limitAdv': '3．広告募集（1社当り限定）件数 {numberAdv}件',
        'register.selectOption': '選択して下さい',
        'register.hostExhibition': '展示会への開催',
        'register.holdSeminar': 'セミナーの開催',
        'register.holdLivestream': 'ライブ配信の開催',
        'register.enterpriseInform': '企業基本情報',
        'register.exhibitionName': '出展企業名',
        'register.jaEn': '（和文・英文）',
        'register.ja': '（和文）',
        'register.en': '（英文）',
        'register.kanaEn': '（カナ・英字）',
        'register.kana': '（カナ）',
        'register.shortEn': '（英字）',
        'register.contactPerson': '連絡担当者',
        'register.guideImage': '出展アピール画像',
        'register.guideInfo': '出展アピール',
        'register.paymentMethod': '支払い方法',
        'register.choosePayment': 'お支払い方法をお選びください。',
        'register.checkExhibit': '出展希望{textZone}は下部の〇にチェックを入れてください。',
        'register.select': '{textSeminar}{textDate}、{textZoom}、{textTimeZone}選択してください。',
        'register.info': '{text}情報',
        'register.suggestRegis': '登録完了',
        'register.textSuggestRegis': 'リクエストが管理者に送信されました。 ご要望が確定しましたら、メールにてご連絡いたします',
        'register.price': '有料・無料',
        'register.totalProduct': '展示商品数 {numberProduct} 展示',
        'register.image': '画像 {numberImage} 枚まで',
        'register.imageTitle': '画像タイトル',
        'register.noteImageTitle': '（12文字×2行）',
        'register.audio': '音声 {numberAudio} 枚まで',
        'register.video': '動画 {numberVideo} 枚まで',
        'register.boothFee': 'ブース料金 円 {price}',
        'register.advRecruitment': '広告募集',
    },
    en: {
        'register.advertisement': 'Advertisement',
        'register.numberAdv': 'Number of ads to apply:',
        'register.item': 'ads',
        'register.feeAdv': '1. Fee per ad: ',
        'register.locationAdv': '2. Ad is displayed on four places: “Bottom of TOP screen of exhibition site”, “Bottom of list of exhibitors”,',
        'register.displayPlaceAdv': '“Bottom of tea room”, and “Exhibition exit site”.',
        'register.limitAdv': '3. Number of advertisers wanted ads (limitation per company): {numberAdv}',
        'register.selectOption': 'Please select',
        'register.hostExhibition': 'Host an exhibition',
        'register.holdSeminar': 'Host a seminar',
        'register.holdLivestream': 'Host a live streaming',
        'register.enterpriseInform': 'Basic information of company',
        'register.exhibitionName': 'Name of exhibitor',
        'register.jaEn': '(Japanese text/English text)',
        'register.ja': '(Japanese text)',
        'register.en': '(English text)',
        'register.kanaEn': '(Katakana/Alphabet)',
        'register.kana': '(Katakana)',
        'register.shortEn': '(English text)',
        'register.contactPerson': 'Contact person',
        'register.guideImage': 'Guide image',
        'register.guideInfo': 'Guide information',
        'register.paymentMethod': 'Payment method',
        'register.choosePayment': 'Please select payment method.',
        'register.checkExhibit': 'To reserve an exhibition {textZone}, please check 〇 below.',
        'register.select': 'Please select {textSeminar} {textDate}, {textZoom}, {textTimeZone}.',
        'register.info': '{text} information',
        'register.suggestRegis': 'Registration completed',
        'register.textSuggestRegis': 'Your request has been submitted to the administrator. Once your request is confirmed, we will contact you via email.',
        'register.price': 'Charged/Free',
        'register.totalProduct': 'Number of products to exhibit: {numberProduct}',
        'register.image': 'Number of images: Up to {numberImage}',
        'register.imageTitle': 'Image title',
        'register.noteImageTitle': '(12 letters * 2 lines)',
        'register.audio': 'Number of audios: Up to {numberAudio}',
        'register.video': 'Number of videos: Up to {numberVideo}',
        'register.boothFee': 'Booth fee: {price} yen',
        'register.advRecruitment': 'Advertisers wanted',
    },
};

export default lang;
